import config from '../config/configureEnv';
import { ajax } from '../utils';

export default {
  generateResetToken: userEmail => ajax('POST', `${config.bocaAPIUrl}/reset-tokens/generate`, {
    data: JSON.stringify({ email: userEmail }),
  }),

  verifyResetToken: (userEmail, token) => ajax('POST', `${config.bocaAPIUrl}/reset-tokens/verify`, {
    data: JSON.stringify({
      email: userEmail,
      token,
    }),
  }),

  updatePassword: (userId, newPassword, accessToken) => ajax('POST', `${config.bocaAPIUrl}/reset-tokens/update-password`, {
    urlParams: { access_token: accessToken },
    data: JSON.stringify({
      id: userId, // this is required for PUT /user/:id
      password: newPassword,
    }),
  }),
};



// WEBPACK FOOTER //
// ./src/api/ForgotPasswordAPIConnectors.js